/** @module api/ems_meta_infos */

import { apiCall } from '@/api/index'
import {
  apiV1EnergyManagementSystemEmsMetaInfoPath,
  apiV1EnergyManagementSystemEmsMetaInfosPath
} from '@/../lib/routes'

export function createEmsMetaInfo({ ctxt, emsId, tag, data }) {
  return apiCall({
    method: 'POST',
    path: apiV1EnergyManagementSystemEmsMetaInfosPath(ctxt, emsId),
    payload: {
      data: {
        id: null,
        type: 'ems_meta_infos',
        attributes: {
          tag,
          data
        }
      }
    }
  })
}

export function deleteEmsMetaInfo({ ctxt, emsId, id }) {
  return apiCall({
    method: 'DELETE',
    path: apiV1EnergyManagementSystemEmsMetaInfoPath(ctxt, emsId, id),
    payload: {}
  })
}

export function getEmsMetaInfos({ ctxt, emsId, tags }) {
  return apiCall({
    path: apiV1EnergyManagementSystemEmsMetaInfosPath(ctxt, emsId),
    payload: {
      filter: {
        tags: [tags]
      }
    }
  })
}

export function updateEmsMetaInfo({ ctxt, emsId, id, data }) {
  return apiCall({
    method: 'PATCH',
    path: apiV1EnergyManagementSystemEmsMetaInfoPath(ctxt, emsId, id),
    payload: {
      data: {
        id,
        type: 'ems_meta_infos',
        attributes: {
          data
        }
      }
    }
  })
}
